(function($, undefined) {
	"use strict";
	
	function init() {
		$('#batch').on('change', toggleCharactersField);
	}

	function toggleCharactersField({currentTarget}) {
		if (currentTarget.checked) {
			$('#promoCodeNameCtn').addClass('field_hidden');
			$('#promoCodeCharacterCtn, #promoCodeCountCtn').removeClass('field_hidden');
		} else {
			$('#promoCodeNameCtn').removeClass('field_hidden');
			$('#promoCodeCharacterCtn, #promoCodeCountCtn').addClass('field_hidden');
		}
	}
	
	$(init);
	
})(jQuery);